import * as React from 'react'

import { ContextMenuTarget } from 'components/ds'

import { useExplorerContextMenusEnabled } from 'hooks/use-explorer-context-menus-enabled'

import BriefProjectMenuBody from '../brief-project-actions/brief-project-menu-body'
import { useBriefProjectMenu } from '../brief-project-actions/use-brief-project-menu'

type Props = {
  children: React.ReactNode
  briefProjectId?: string
}

/**
 * Opens the brief project's three-dot menu on right-click anywhere in
 * `children`.
 */
const BriefProjectContextMenu = ({
  children,
  briefProjectId,
}: Props): React.ReactNode => {
  const contextMenusEnabled = useExplorerContextMenusEnabled()

  // Skip useBriefProjectMenu's state entirely while the flag is off, rather
  // than calling it on every row and disabling ContextMenuTarget after.
  if (!contextMenusEnabled || !briefProjectId) return children

  return (
    <BriefProjectContextMenuContent briefProjectId={briefProjectId}>
      {children}
    </BriefProjectContextMenuContent>
  )
}

const BriefProjectContextMenuContent = ({
  children,
  briefProjectId,
}: {
  children: React.ReactNode
  briefProjectId: string
}): React.ReactNode => {
  const {
    handleRenameProject,
    handleOpenSettings,
    handleDeleteProject,
    dialogs,
  } = useBriefProjectMenu({ briefProjectId })

  return (
    <>
      <ContextMenuTarget
        menu={
          <BriefProjectMenuBody
            handleRenameProject={handleRenameProject}
            handleOpenSettings={handleOpenSettings}
            handleDeleteProject={handleDeleteProject}
          />
        }
      >
        {children}
      </ContextMenuTarget>
      {dialogs}
    </>
  )
}

export default BriefProjectContextMenu
